module.exports = __webpack_public_path__ + "assets/minimum-8fdd07.svg";